export default __webpack_public_path__ + "static/media/02.0b048d8b.png";